var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ItpModal",
    {
      attrs: {
        noHeader: _vm.b_7315092382398562_noHeader,
        "no-primary-button": "",
        size: _vm.size,
        header: _vm.documentTitle,
        loaded: _vm.loaded,
        noShow: !_vm.loaded,
        modal: _vm.modal,
        "itp-cname": "DataViewerModal"
      },
      on: {
        close: function($event) {
          return _vm.evh_7315092382398562_close($event, {})
        }
      }
    },
    [
      _c(
        "DIV",
        { staticClass: "container-fluid" },
        [
          _c("CodeMirror", {
            attrs: { mode: _vm.mode, options: _vm.b_8564662037462133_options },
            model: {
              value: _vm.inputData,
              callback: function($$v) {
                _vm.inputData = $$v
              },
              expression: "inputData"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _vm.loaded ? _c("template", { slot: "footer" }) : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }